import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es.array.concat.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { defineComponent as _defineComponent } from 'vue';
import { useListSectionsQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'Sections',
  props: {
    query: Object,
    'add-all': {
      type: Boolean,
      default: true
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var variables = computed(function () {
      return {
        filters: _objectSpread({}, props.query)
      };
    });
    var _useListSectionsQuery = useListSectionsQuery(variables),
      result = _useListSectionsQuery.result;
    var open = ref([0]);
    var sectionItems = computed(function () {
      var _result$value;
      var sections = [].concat(_toConsumableArray(((_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.listSections) || []), _toConsumableArray(props.allowCustom ? [{
        active: true,
        leaf: true,
        description: '',
        label: '',
        id: -1,
        sections: []
      }] : []));
      if (props['add-all']) {
        return [{
          active: true,
          id: 0,
          label: '',
          sections: sections
        }];
      } else {
        return sections;
      }
    });
    return {
      __sfc: true,
      props: props,
      variables: variables,
      result: result,
      open: open,
      sectionItems: sectionItems
    };
  }
});